import { Typography } from "@mui/material";

const Home: React.FC = () => {
  return <Typography>Home</Typography>;
};

export default Home;
